import {alpha, lighten} from '@material-ui/core/styles/colorManipulator';

import {MuiPickersOverrides} from '@material-ui/pickers/typings/overrides';
import {Theme} from '@material-ui/core/styles/createMuiTheme';

export const createMuiPickersDayOverrides = ({
    palette,
    typography
}: Theme): MuiPickersOverrides['MuiPickersDay'] => ({
    day: {
        ...typography.body1,
        color: palette.text.secondary,
        borderRadius: '50%'
    },
    current: {
        backgroundColor: palette.action.selected,
        color: palette.text.secondary,

        '&:hover': {
            backgroundColor: alpha(
                palette.text.primary,
                palette.action.selectedOpacity + palette.action.hoverOpacity
            )
        },

        '&.Mui-focusVisible': {
            backgroundColor: alpha(
                palette.text.primary,
                palette.action.selectedOpacity + palette.action.focusOpacity
            )
        },

        '&:active': {
            backgroundColor: alpha(
                palette.text.primary,
                palette.action.selectedOpacity + palette.action.activatedOpacity
            )
        }
    },
    daySelected: {
        '&&': {
            backgroundColor: palette.primary.main,

            '&:hover': {
                backgroundColor: lighten(palette.primary.main, palette.action.hoverOpacity)
            },

            '&.Mui-focusVisible': {
                backgroundColor: lighten(palette.primary.main, palette.action.focusOpacity)
            },

            '&:active': {
                backgroundColor: lighten(palette.primary.main, palette.action.activatedOpacity)
            }
        }
    },
    dayDisabled: {
        color: palette.text.secondary,
        opacity: palette.action.disabledOpacity
    }
});
